
import { definitionsFromContext } from "stimulus/webpack-helpers";
import application from "stimulus_application";
import "./slider_with_semi_visible_next_slide.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
